import React from "react";
import { FaRegFileAlt } from "react-icons/fa";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { FiClock } from "react-icons/fi";

const Notifications = () => {
  const notifications = [
    {
      id: 1,
      icon: <FaRegFileAlt className="h-6 w-6 text-blue-500" />,
      text: "5 Providers document expiry in 1 week"
    },
    {
      id: 2,
      icon: <IoCheckmarkCircleOutline className="h-6 w-6 text-green-500" />,
      text: "5 Providers waiting for Registration approval",
    },
    {
      id: 3,
      icon: <FiClock className="h-6 w-6 text-gray-500" />,
      text: "5 Support requests waiting for reply",
    },
  ];
  return (
    <>
      <div className="px-4 md:px-10 mt-4">
        <div className="border border-1 px-4 py-3 rounded-t-2xl text-xl mt-4 bg-white">
          <div className="flex justify-between">
            <p className="text-[#284184] font-bold">Notifications</p>
          </div>
        </div>
        <div className="border border-t-0 text-xl bg-white px-3 py-2">
          <div className="mt-4 space-y-3">
            {notifications.map((notification) => (
              <div
                key={notification.id}
                className={`flex items-center p-2 rounded-lg border  shadow-sm`}
              >
                <div className={`p-2 rounded-lg shadow-sm bg-[#F4F9FF]`}>
                  {notification.icon}
                </div>
                <p className="ml-4 text-base text-[#8B8D98]">{notification.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Notifications;
